import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFunction, URL } from "../utils";
import { baseQueryWithReauth } from "../baseQueryWithReauth";
import { serializeArgsWithoutToken } from "../serializeQueryArgs";

const offerApi = createApi({
  reducerPath: "offer",
  baseQuery: baseQueryWithReauth,
  serializeQueryArgs: serializeArgsWithoutToken, // #142: token önbellek anahtarına girmez
  tagTypes: ["Offer"],
  keepUnusedDataFor: 120,
  endpoints(builder) {
    return {
      generatePDF: builder.mutation({
        queryFn: async (input, _queryApi, _extraOptions, _fetchWithBQ) => {
          const requestConfig = apiFunction(input, "/api/pdf/storageRoles/offer-generate", "POST");
          const fullUrl = `${URL.url.replace(/\/$/, '')}${requestConfig.url}`;
          try {
            const response = await fetch(fullUrl, {
              method: requestConfig.method,
              headers: { ...requestConfig.headers, 'Content-Type': 'application/json' },
              body: JSON.stringify(requestConfig.body),
              credentials: 'include',
            });
            if (!response.ok) {
              const errorText = await response.text().catch(() => 'Hata mesajı alınamadı');
              return { error: { status: response.status, data: `PDF API hatası: ${response.status} - ${errorText}` } };
            }
            const blob = await response.blob();
            if (!blob || blob.size === 0) {
              return { error: { status: 'CUSTOM_ERROR', data: 'PDF oluşturulamadı: Boş response' } };
            }
            return { data: blob };
          } catch (error) {
            return { error: { status: 'FETCH_ERROR', data: error.message || 'Network hatası' } };
          }
        },
      }),

      // Sade Teklif PDF indir
      generateSimpleOfferPDF: builder.mutation({
        queryFn: async (input, _queryApi, _extraOptions, _fetchWithBQ) => {
          const requestConfig = apiFunction(input, "/api/pdf/storageRoles/simple-offer-generate", "POST");
          const fullUrl = `${URL.url.replace(/\/$/, '')}${requestConfig.url}`;
          try {
            const response = await fetch(fullUrl, {
              method: requestConfig.method,
              headers: { ...requestConfig.headers, 'Content-Type': 'application/json' },
              body: JSON.stringify(requestConfig.body),
              credentials: 'include',
            });
            if (!response.ok) {
              const errorText = await response.text().catch(() => 'Hata mesajı alınamadı');
              return { error: { status: response.status, data: `PDF API hatası: ${response.status} - ${errorText}` } };
            }
            const blob = await response.blob();
            if (!blob || blob.size === 0) {
              return { error: { status: 'CUSTOM_ERROR', data: 'PDF oluşturulamadı: Boş response' } };
            }
            return { data: blob };
          } catch (error) {
            return { error: { status: 'FETCH_ERROR', data: error.message || 'Network hatası' } };
          }
        },
      }),

      // Sade Teklif Email gonder
      sendSimpleOfferEmail: builder.mutation({
        query: (data) =>
          apiFunction(data, "/api/pdf/storageRoles/simple-offer-send-email", "POST"),
      }),
    };
  },
});

export const {
  useGeneratePDFMutation,
  useGenerateSimpleOfferPDFMutation,
  useSendSimpleOfferEmailMutation,
} = offerApi;

export { offerApi };
